import * as yup from 'yup'

import 'configs/yup'

const schema = yup.object().shape({
  deadlineDay: yup.number().required().min(1),
  companyDeadlineDay: yup
    .number()
    .required()
    .min(1)
    .when('deadlineDay', (deadlineDay, schemaItem) =>
      deadlineDay
        ? schemaItem.max(deadlineDay, 'Não pode ser maior que o prazo total')
        : schemaItem,
    ),
})

export default schema
